<template>
  <div class="container">
    <div class="content">
      <div class="header flex-between bold">
        <!-- <img class="logo" :src="logo" /> -->
        <div class="logo center">务实软件<br />wushisoft</div>
        <p class="describe">—— 助力企业建立<i>“不依赖人治”</i>的流程 管理体系！</p>
        <div class="phone flex-column">
          <el-popover :hide-after="0" trigger="hover" width="100">
            <template #reference>
              <em>售前：电话/微信:<span>134-2145-3478</span></em>
            </template>
            <img :src="require('@/assets/images/friend1.jpg')">
          </el-popover>
          <p>
            <el-popover :hide-after="0" trigger="hover" width="100">
              <template #reference>
                <em>售后：电话/微信:<span>180-2992-7715 </span></em>
              </template>
              <img :src="require('@/assets/images/friend2.jpg')">
            </el-popover>
            QQ:<span>80144944</span>
          </p>
        </div>
      </div>
      <navBar :curNav="props.curNav" />
    </div>
    <slot />
    <div class="floor">
      <div class="main flex-between">
        <ul>
          <li>核心产品</li>
          <li v-for="item in goods" :key="item.id"><router-link :to="`/productInfo/${item.id}`">{{item.name}}</router-link></li>
        </ul>
        <ul>
          <li>新闻资讯</li>
          <li><router-link :to="item.to" v-for="item in newsData" :key="item.text">{{item.text}}</router-link></li>
        </ul>
        <ul>
          <li>联系我们</li>
          <li><router-link to="/aboutUs">联系我们</router-link></li>
          <li><router-link to="/joinUs">加入我们</router-link></li>
        </ul>
        <div class="contact">
          <b></b><p class="p4">134-2145-3478</p><div class="erweima"><em></em><span>关注我们</span></div>
          <div class="wz1">
              <span>24小时服务热线：</span><br>电话：134-2145-3478
          </div>
          <div class="wz2">
              <span>微信：13421453478&nbsp;&nbsp;&nbsp;QQ：455671256</span>
              <span>邮箱：455671256@qq.com</span>
              <em>地址：中山市横栏镇西区街道长安北路盛雅华庭7栋102</em>
          </div>
      </div>
      </div>
      <div class="bottom">
        <div class="main">
          <span>版权所属：©2024-2025 中山市横栏镇务实软件销售部</span>
          <span>备案号：123456789</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineComponent, defineProps } from 'vue'
import navBar from "@/components/navBar.vue";
import friend1 from "@/assets/images/friend1.jpg";
const props = defineProps({
  curNav: {
    type: String,
    default: ''
  }
})
defineComponent({
  components: { navBar }
})

const goods = [
  { id: 1, name: '简易ERP' },
  { id: 2, name: '完整ERP'},
  { id: 3, name: '定制软件'}
]

const newsData = [{ text: "什么是云软件？其优势是什么？", to: "/newsList" }, { text: "Docker容器技术的优势是什么？", to: "/newsList" }, { text: "年终盛典，速达天耀软件帮您充话费", to: "/newsList" }]

</script>

<style scoped lang="scss">
.container {
  padding-top: 102px;
  padding-bottom: 264px;
  position: relative;
  .content {
    position: fixed;
    background: #fff;
    z-index: 999;
    width: 100%;
    top: 0;
    .header {
      width: 100%;
      padding: 0 2%;
      box-sizing: border-box;
      height: 60px;
      font-size: 14px;
      .logo {
        color: $master-color;
        font-size: 22px;
      }
      .describe {
        margin-left: 40px;
        margin-right: auto;
        color: $master-color;
        i {
          color: $red;
          font-size: 18px;
        }
      }
      .phone {
        align-items: flex-start;
        color: $font-color;
        span {
          color: $master-color;
          margin-right: 5px;
        }
      }
    }
  }
  .floor {
    background: #363636;
    position: absolute;
    bottom: 0;
    width: 100%;
    &>.main {
      padding: 20px 0;
      box-sizing: border-box;
      align-items: flex-start;
      ul li {
        height: 31px;
        line-height: 31px;
        a {
          font-size: 14px;
          display: block;
          color: #a3a8b1;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          &:hover {
            color: $master-color;
          }
        }
        &:first-child {
          font-size: 16px;
          white-space: nowrap;
          color: #eee;
        }
      }
      .contact {
        width: 415px;
        float: right;
        position: relative;
        b {
          width: 46px;
          height: 1px;
          background: $master-color;
          display: block;
          margin-top: 20px;
          float: left;
        }
        .p4 {
          font-size: 24px;
          font-weight: bold;
          color: $master-color;
          margin-left: 15px;
          float: left;
        }
        .erweima {
          float: right;
          width: 112px;
          height: 84px;
          em {
            width: 84px;
            height: 84px;
            float: left;
            background: url("@/assets/images/friend1.jpg") no-repeat center;
            background-size: cover;
          }
          span {
            color: $master-color;
            float: right;
            width: 28px;
            height: 100%;
            font-size: 14px;
            background: #1f1f1f;
            writing-mode: tb;
            line-height: 28px;
            text-align: center;
          }
        }
        .wz1 {
          font-weight: 500;
          margin: 10px 0 0 66px;
          color: #a3a8b1;
          float: left;
          span {
            font-size: 14px;
            line-height: 18px;
          }
        }
        .wz2 {
          float: left;
          margin: 10px 0 0 28px;
          span,
          em {
            display: block;
            font-size: 14px;
            line-height: 30px;
            color: #a3a8b1;
          }
        }
      }
    }
    .bottom {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: $master-color;
      color: #fff;
      .main span:nth-child(2) {
        padding: 0 20px;
      }
    }
  }
}
.el-popper {
  text-align: center;
  img{
    display: block;
    width: 100px;
    margin: 0 auto;
  }
}
</style>
